import { useNavigate } from "react-router-dom";
import { useContextSite } from "../context/Context";
import { StatusAgendamentoEnum } from "../enums/statusAgendamento";
import { IAgendamentoDTO } from "../types/agendamento";
import { useSessionStorage } from "./useSessionStorage";

/**
 * Reagendamento eligibility + navigation for an agendamento, shared by the
 * standalone "Reagendar" button and the "Reagendar" item of `ButtonOptionsV3`.
 * Mirrors the rule/flow that `ButtonOptionsV2` keeps internally.
 */
export const useReagendarAgendamento = (agendamento?: IAgendamentoDTO) => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const [sessionAgendamento, setSessionagendamento] =
    useSessionStorage("@usuarioMapa");

  const canReagendar =
    agendamento?.status === StatusAgendamentoEnum.AGENDADO ||
    (agendamento?.status === StatusAgendamentoEnum.PAGO &&
      agendamento?.itinerante != null);

  function onRescheduling() {
    setIsLoad(true);
    setSessionagendamento({
      ...sessionAgendamento,
      uuidAgendamento: agendamento?.uuid,
      reagendamento: true,
    });
    setTimeout(() => {
      agendamento?.itinerante
        ? navigate(`/agendamento/${agendamento.uuid}/itinerantes`)
        : navigate(`/agendamento/${agendamento?.uuid}/loja?reagendamento=true`);

      setIsLoad(false);
    }, 1000);
  }

  return { canReagendar, onRescheduling };
};
